import Helpers from "@/helpers/Helpers";

export default [
  {
    path: "clients/:clientId/sites/:siteId/gps-geofences/:gpsGeofenceId/edit",
    name: "GpsGeofenceEdit",
    components: { default: Helpers.lazyLoad("GpsGeofenceAddEditView", "views/content/gpsGeofences") },
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/gps-geofences/:gpsGeofenceId(add)",
    name: "GpsGeofenceAdd",
    components: { default: Helpers.lazyLoad("GpsGeofenceAddEditView", "views/content/gpsGeofences") },
    meta: { requiresAuth: true }
  }
];
